export default "__VITE_ASSET__Bt6ww62d__"